export default "__VITE_ASSET__VY$9YfhC__"